// Mini split-shield glyph indicating which legal-doc track(s) a control covers:
//   'estimate' → LEFT half filled, 'invoice' → RIGHT half filled, 'both' → full.
// Mirrors the shop AuthorizedDot shield (left=estimate / right=invoice) but as a
// fixed-color SCOPE indicator (which track), not a safe/unsafe state indicator.
// Shared by the shop "Capture as" picker and the admin doc-type filter so both
// speak the same left/right/full visual language.

import { useId } from 'react';

const ESTIMATE = '#22C55E'; // green — matches the estimate doc_type badge
const INVOICE = '#6366F1'; // indigo — matches the invoice doc_type badge
const MUTED = '#3F3F46'; // inactive half

// Classic shield outline in a 24x24 box, split vertically at x=12.
const SHIELD_PATH = 'M12 2 L20 5 V11 C20 16.5 16.5 20.5 12 22 C7.5 20.5 4 16.5 4 11 V5 Z';

export function TrackShield({
  track,
  size = 13,
}: {
  track: 'estimate' | 'invoice' | 'both';
  size?: number;
}) {
  const clipId = useId();
  const left = track === 'invoice' ? MUTED : ESTIMATE;
  const right = track === 'estimate' ? MUTED : INVOICE;
  const px = size + 2;
  return (
    <svg width={px} height={px} viewBox="0 0 24 24" aria-hidden="true" style={{ display: 'block' }}>
      <defs>
        <clipPath id={clipId}>
          <path d={SHIELD_PATH} />
        </clipPath>
      </defs>
      <g clipPath={`url(#${clipId})`}>
        <rect x={0} y={0} width={12} height={24} fill={left} />
        <rect x={12} y={0} width={12} height={24} fill={right} />
      </g>
      {/* center divider + crisp shield border */}
      <line x1={12} y1={3} x2={12} y2={21} stroke="#ffffff" strokeWidth={0.9} opacity={0.6} />
      <path d={SHIELD_PATH} fill="none" stroke="#0f172a" strokeOpacity={0.35} strokeWidth={1.2} />
    </svg>
  );
}
